<template>
  <div class="pdf">
    <pdf v-loading="loading" v-for="i in numPages" :key="i" :src="pdfUrl" :page="i"></pdf>
  </div>
</template>
<script>
import pdf from "vue-pdf";
import pagePathMixin from '@/utils/page-path-mixin'
export default {
  name: "Pdf",
  mixins: [pagePathMixin],
  components: {
    pdf
  },
  data() {
    return {
      loading: true,
      pdfUrl: "",
      numPages: 1,
      activeIndex: 0
    };
  },
  mounted: function() {
    this.pdfTask(this.$route.query.pdfUrl);
  },
  methods: {
    pdfTask(pdfUrl) {
      console.log("pdfUrl", pdfUrl);

      var self = this;
      var loadingTask = pdf.createLoadingTask(pdfUrl);
      loadingTask.promise
        .then(pdf => {
          self.pdfUrl = loadingTask;
          self.numPages = pdf.numPages;
          this.loading = false;
        })
        .catch(err => {
          console.error("pdf加载失败");
        });
    }
  }
};
</script>